import { createRescheduleService } from '@shared/api'
import { authorizedHttpClient } from './http-client'

export const RescheduleService = createRescheduleService(authorizedHttpClient, import.meta.env.VITE_API_URL)
